import React from 'react';
import ReactMarkdown from 'react-markdown';
import './styles.module.scss';
import { useTranslation } from 'react-i18next';

const TermsOfUse = () => {
	const { t } = useTranslation();
	const markdown = `
# ${t('terms_of_use')}

Paycor API License Agreement, dated December 8, 2020

${t('this_paycor_api_license_agreement')}

${t('before_connecting_to_or_building')}

${t('this_agreement_sets_forth_rules')}

${t('because_this_is_binding_legel_agreement')}

${t('if_you_feel_that_we_should')}

1. ${t('description_licenses_and_restrictions')}

1.1 ${t('terms_of_use_1_1')}

1.2 ${t('terms_of_use_1_2')}

1.3 ${t('terms_of_use_1_3')}

1.4 ${t('terms_of_use_1_4')}

  - ${t('terms_of_use_1_4_a')}

  - ${t('terms_of_use_1_4_b')}

  - ${t('terms_of_use_1_4_c')}

  - ${t('terms_of_use_1_4_d')}

  - ${t('terms_of_use_1_4_e')}

  - ${t('terms_of_use_1_4_f')}

  - ${t('terms_of_use_1_4_g')}

  - ${t('terms_of_use_1_4_h')}

  - ${t('terms_of_use_1_4_i')}

  - ${t('terms_of_use_1_4_j')}

  - ${t('terms_of_use_1_4_k')}

  - ${t('terms_of_use_1_4_l')}

  - ${t('terms_of_use_1_4_m')}

  - ${t('terms_of_use_1_4_n')}

  - ${t('terms_of_use_1_4_o')}

  - ${t('terms_of_use_1_4_p')}

1.5 ${t('terms_of_use_1_5')}

1.6 ${t('terms_of_use_1_6')}

1.7 ${t('terms_of_use_1_7')}

1.8 ${t('terms_of_use_1_8')}

1.9 ${t('terms_of_use_1_9')}

1.10 ${t('terms_of_use_1_10')}

2. ${t('terms_of_use_2')}

2.1 ${t('terms_of_use_2_1')}

2.2 ${t('terms_of_use_2_2')}

2.3 ${t('terms_of_use_2_3')}

${t('at_no_time_during')}

${t('in_using_the_paycor_marks')}

- ${t('terms_of_use_2_3_a')}

- ${t('terms_of_use_2_3_b')}

- ${t('terms_of_use_2_3_c')}

- ${t('terms_of_use_2_3_d')}

- ${t('terms_of_use_2_3_e')}

- ${t('terms_of_use_2_3_f')}

- ${t('terms_of_use_2_3_g')}

- ${t('terms_of_use_2_3_h')}

2.4 ${t('terms_of_use_2_4')}

2.5 ${t('terms_of_use_2_5')}

2.6 ${t('terms_of_use_2_6')}

3. ${t('terms_of_use_3')}

3.1 ${t('terms_of_use_3_1')}

3.2 ${t('terms_of_use_3_2')}

3.3 ${t('terms_of_use_3_3')}

4. ${t('terms_of_use_4')}

${t('you_are_free_to_promote_app')}

5. ${t('terms_of_use_5')}

${t('you_are_agree_to_indemnity')}

6. ${t('terms_of_use_6')}

${t('you_expressly_understand_that')}

7. ${t('terms_of_use_7')}

${t('you_expressly_understand_paycore')}

8. ${t('terms_of_use_8')}

${t('the_term_payco_confidential')}

9. ${t('terms_of_use_9')}

9.1 ${t('terms_of_use_9_1')}

9.2 ${t('terms_of_use_9_2')}

9.3 ${t('terms_of_use_9_3')}

9.4 ${t('terms_of_use_9_4')}

9.5 ${t('terms_of_use_9_5')}

9.6 ${t('terms_of_use_9_6')}

9.7 ${t('terms_of_use_9_7')}

10. ${t('terms_of_use_10')}

10.1 ${t('terms_of_use_10_1')}

10.2 ${t('terms_of_use_10_2')}

10.3 ${t('terms_of_use_10_3')}

10.4 ${t('terms_of_use_10_4')}

10.5 ${t('terms_of_use_10_5')}

10.6 ${t('terms_of_use_10_6')}

10.7 ${t('terms_of_use_10_7')}

10.8 ${t('terms_of_use_10_8')}

10.9 ${t('terms_of_use_10_9')}

10.10 ${t('terms_of_use_10_10')}

10.11 ${t('terms_of_use_10_11')}

`;

	return (
		<section>
			<flex-container>
				<inner-flex>
					<prose-mirror className="block">
						<ReactMarkdown source={markdown} escapeHtml={false} />
					</prose-mirror>
				</inner-flex>
			</flex-container>
		</section>
	);
};

export default TermsOfUse;
